import { render } from "./Q14-ChooseGround.vue?vue&type=template&id=67f6721c&scoped=true"
import script from "./Q14-ChooseGround.vue?vue&type=script&lang=js"
export * from "./Q14-ChooseGround.vue?vue&type=script&lang=js"

import "./Q14-ChooseGround.vue?vue&type=style&index=0&id=67f6721c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f6721c"]])

export default __exports__